import { AdgroupFormData, CampaignFormData, AdgroupConfig } from '@tt4b/ttam-enums';
import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import TtamCopyBatchWrap from '@/components/common/batch-wrap/index.vue';
import { useStdAdgroupIs, useAdgroupAgeOptions, useAdgroupAgeValidate, useValidateU18 } from '@tt4b/ttam-hooks';
import TtamAge from './age/index.vue';
import TtamAgeTips from './tips/index.vue';
import TtamAgeAlert from './alert/index.vue';

import { usePropsAgeLegalPromptVisible, useAgeDisabled } from './hooks';

const name = 'ttam-age-compose';
export default defineComponent({
  name,
  components: {
    TtamAge,
    TtamAgeTips,
    TtamCopyBatchWrap,
    TtamAgeAlert,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    batchFormData: {
      type: Array as PropType<Partial<AdgroupFormData>[]>,
      default: () => [],
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData } = toRefs(props);
    const { isReal1pShop, isProductFromShowcase, isPSA } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const age = computed(() => props.adgroupData.age);
    const _age = computed({
      get: () => adgroupData.value.age,
      set: val => {
        emit('change', val);
      },
    });
    const { ageValidator } = useAdgroupAgeValidate({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });
    const { disableStatus } = useAgeDisabled({ campaignData, adgroupData });
    const { ageOptions } = useAdgroupAgeOptions({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { isShowAgeLegalPrompt } = usePropsAgeLegalPromptVisible({ age });

    // (include US || only US) && (选了all 或者 include 13-17)
    const { isCloseLoopIncludeUsAllOr1317 } = useValidateU18({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });
    const onAdgroupDataChange = data => {
      emit('adgroupDataChange', data);
    };
    const onCopyDataChange = data => {
      emit('copyDataChange', data);
    };
    return {
      name,
      _age,
      isReal1pShop,
      isProductFromShowcase,
      ageOptions,
      disableStatus,
      isShowAgeLegalPrompt,
      isPSA,
      onAdgroupDataChange,
      onCopyDataChange,
      ageValidator,
      isCloseLoopIncludeUsAllOr1317,
    };
  },
});
